import { useForm } from "react-hook-form";
import {
  IPlannerEventSignUpFormModel,
  plannerEventSignUpFormDefaultValues,
  plannerEventSignUpFormSchema,
} from "../models/plannerEventSignUpFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useFormValidationMessages } from "../../../../common/infrastructure/hooks/useFormHelper";

export const usePlannerEventSignUpForm = (
  eventId?: number,
  eventPrice?: number,
  users?: IUserDropdownOption[]
) => {
  const form = useForm<IPlannerEventSignUpFormModel>({
    defaultValues: plannerEventSignUpFormDefaultValues,
    resolver: yupResolver(plannerEventSignUpFormSchema),
  });

  useEffect(() => {
    if (eventPrice) {
      form.setValue("price", eventPrice);
    }
  }, [eventId, eventPrice, users]);

  useFormValidationMessages<IPlannerEventSignUpFormModel>(form);

  return form;
};
